import type { GiftDetail, GiftProduct, PaginatedResponse } from '@/shared/@types';

import { giftApi } from '@/shared/apis/apiClient';
import { httpsClient } from '@/shared/utils';

export type GiftDetailResponse = GiftDetail;

/** Gift 상세 정보 요청 함수 */
const detailRequest = (giftNo: number) =>
  httpsClient<GiftDetailResponse>({
    url: `/app/api/gift/detail/${giftNo}`,
    apiClient: giftApi.requestGet,
  });

/** Gift 상세 정보 API 호출 */
export const detail = (giftNo: number) => detailRequest(giftNo)();

/** Gift 상품 목록 데이터 타입 */
export type GiftGoodsData = {
  list: Array<GiftProduct>;
};

/** Gift 상품 목록 응답 타입 (페이지네이션 포함) */
export type GiftGoodsResponse = PaginatedResponse<GiftGoodsData>;

/** Gift 상품 목록 요청 함수 */
const goodsRequest = (giftNo: number, cursor?: string) =>
  httpsClient<GiftGoodsData, GiftGoodsResponse>({
    url: `/app/api/gift/goods`,
    apiClient: giftApi.requestGet,
    defaultParameters: {
      giftNo: String(giftNo),
      ...(cursor && { cursor }),
    },
  });

/** Gift 상품 목록 API 호출 */
export const goods = (giftNo: number, cursor?: string) => goodsRequest(giftNo, cursor)();
